<template>
  <ValidationProvider
    v-slot="{ errors }"
    v-bind="validationAttr"
  >
    <BFormGroup
      v-bind="formGroupAttr"
      :label-for="inputID"
    >
      <template
        v-if="useTextCounter"
        #label
        :for="inputID"
      >
        <div class="d-flex justify-content-between">
          <b>{{ formGroupAttr?.label || '' }}</b>
          <span class="font-weight-normal">{{ proxyValue ? proxyValue.length : 0 }} / {{ formGroupAttr?.maxlength || 0 }}</span>
        </div>
      </template>
      <BFormTextarea
        v-if="preventNewline"
        :id="inputID"
        v-model="proxyValue"
        v-bind="$attrs"
        :state="errors.length > 0 ? false : null"
        @keydown="preventEnterKey"
      />
      <BFormTextarea
        v-else
        :id="inputID"
        v-model="proxyValue"
        v-bind="$attrs"
        :state="errors.length > 0 ? false : null"
      />
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import MxMisc from '@/mixins/misc'

export default {
  name: 'WVTextarea',

  mixins: [
    MxMisc
  ],

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    validationAttr: {
      type: Object,
      default: () => ({})
    },
    formGroupAttr: {
      type: Object,
      default: () => ({})
    },
    preventNewline: {
      type: Boolean,
      default: false
    },
    useTextCounter: {
      type: Boolean,
      default: false
    }
  },

  emits: ['input'],

  data () {
    return {
      proxyValue: '',
      inputID: `WVID_${String(this.generateId(10)).toUpperCase()}_${this._uid}`
    }
  },

  watch: {
    value (val) {
      this.proxyValue = val
    },
    proxyValue (val) {
      this.$emit('input', val)
    }
  },

  mounted () {
    this.proxyValue = this.value
  }
}
</script>
